import {afterNextRender, ChangeDetectionStrategy, Component, input, viewChild} from '@angular/core'
import {Gallery, GalleryComponent as NgGallery, GalleryImageDef, GalleryItem} from 'ng-gallery'
import {transformBuildigoImageUrl} from '../../../core/picture/loaders/buildigo-image-api'
import {GallerizeDirective} from 'ng-gallery/lightbox'
import {NgClass} from '@angular/common'

@Component({
  selector: 'bgo-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css'],
  imports: [GallerizeDirective, NgGallery, GalleryImageDef, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryComponent {
  galleryId = input.required<string>()
  items = input.required({
    transform: (images: GalleryImage[]) => {
      return images.map(
        i =>
          new ImageItem({
            src: transformBuildigoImageUrl(i.url, {format: 'avif'}),
            thumb: transformBuildigoImageUrl(i.url, {width: 200, format: 'avif'}),
            sm: transformBuildigoImageUrl(i.url, {width: 200, format: 'avif'}),
            title: i.title,
            description: i.description,
            alt: i.title ?? '',
          }),
      )
    },
  })
  loadingStrategy = input<'preload' | 'lazy' | 'default'>('preload')
  showThumbnails = input(true)
  flushMobileBottom = input(false)
  imageDef = viewChild(GalleryImageDef)
  counterPosition = input<'top' | 'bottom'>('top')

  constructor(public gallery: Gallery) {
    afterNextRender({
      mixedReadWrite: () => {
        this.gallery
          .ref('lightbox', {
            imageTemplate: this.imageDef()?.templateRef,
          })
          .load(this.items())
      },
    })
  }
}

export interface GalleryImage {
  title?: string
  description?: string
  url: string
}

class ImageItem implements GalleryItem {
  readonly type = 'image'

  constructor(readonly data: ImageItemProps) {}
}

interface ImageItemProps {
  src: string
  sm: string
  thumb: string
  title?: string
  description?: string
  alt?: string
}
